import AttachmentField from '../components/AttachmentField';
import { submitRequest } from '../lib/submitRequest';
import {
  ArrowRight,
  Award,
  Calendar,
  CheckCircle2,
  ClipboardList,
  Crown,
  Globe,
  Heart,
  MapPin,
  MessageCircle,
  Music,
  Palette,
  PartyPopper,
  Send,
  ShieldCheck,
  Sparkles,
  Star,
  Target,
  Users,
} from 'lucide-react';
import { useEffect, useState } from 'react';

// ⚠️ PHOTOS DES 3 PAYS — EVENTS (sans drapeaux)
import franceSoiree from '../assets/hero-evenementiel/soiree-privee.png';
import senegalHenne from '../assets/hero-evenementiel/henne-time.jpg';
import marocMariage from '../assets/hero-evenementiel/mariagemarocain.jpg';

// ⚠️ SLIDES DU HERO — DESKTOP (3 images)
import heroImg1 from '../assets/hero-evenementiel/senegal1.png';
import heroImg2 from '../assets/hero-evenementiel/maroc2.png';
import heroImg3 from '../assets/hero-evenementiel/maroc3.png';

// ⚠️ SLIDES DU HERO — MOBILE (images dédiées, format portrait)
import heroMobile1 from '../assets/hero-evenementiel/mobile4.png';
import heroMobile3 from '../assets/hero-evenementiel/mobile2.png';
import heroMobile4 from '../assets/hero-evenementiel/mobile3.png';

// ================== CONFIG FORMULAIRE DEVIS ==================

const WHATSAPP_NUMBER = '33698681150';
const WHATSAPP_DISPLAY = '+33 6 98 68 11 50';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  'Bonjour MCE, je souhaite un devis pour un accompagnement mariage / soirée privée.'
)}`;

const SERVICES = ['Mariage', 'Soirée à thème'];

const AUDIENCE_SIZES = [
  'Moins de 30 personnes',
  '30 à 80 personnes',
  '80 à 150 personnes',
  '150 à 300 personnes',
  'Plus de 300 personnes',
];

const DEADLINES = [
  'Dans le mois',
  '1 à 3 mois',
  '3 à 6 mois',
  '6 à 12 mois',
  'Plus de 12 mois',
];

/* Icône WhatsApp officielle (SVG inline) */
const WhatsAppIcon = ({ className = 'w-5 h-5' }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

// ================== CONFIG DES SLIDES (3 slides avec mobile4 en premier) ==================
const HERO_SLIDES = [
  {
    desktopImg: heroImg1,
    mobileImg: heroMobile1,
    colorDesktop: 'navy',
    colorMobile: 'navy',
    line1: 'Des événements ',
    line2: 'qui marquent les esprits.',
    desc: 'Mariages somptueux, soirées privées et réceptions sur-mesure : MCE conçoit et coordonne vos moments les plus précieux en France, au Sénégal et au Maroc.',
  },
  {
    desktopImg: heroImg2,
    mobileImg: heroMobile4,
    colorDesktop: 'white',
    colorMobile: 'white',
    line1: 'Illuminer',
    line2: 'chaque célébration.',
    desc: 'Cérémonies lumineuses, décors féeriques et mises en scène qui transforment chaque instant en souvenir éternel.',
  },
  {
    desktopImg: heroImg3,
    mobileImg: heroMobile3,
    colorDesktop: 'navy',
    colorMobile: 'navy',
    line1: 'Célébrer',
    line2: 'avec grandeur.',
    desc: "Mariages traditionnels et modernes, dans le respect des rites, de l'émotion et de l'excellence.",
  },
];

const COLOR_MAP = {
  navy: {
    main: 'text-mce-navy',
    accent: 'text-mce-navy/60',
    desc: 'text-mce-navy/75',
    label: 'text-mce-navy',
    iconBorder: 'border-mce-navy/30',
    iconFill: 'text-mce-navy',
    dotActive: 'bg-mce-navy',
    dotInactive: 'bg-mce-navy/25 hover:bg-mce-navy/50',
  },
  white: {
    main: 'text-white',
    accent: 'text-white/70',
    desc: 'text-white/80',
    label: 'text-white',
    iconBorder: 'border-white/40',
    iconFill: 'text-white',
    dotActive: 'bg-white',
    dotInactive: 'bg-white/40 hover:bg-white/70',
  },
  gold: {
    main: 'text-mce-gold',
    accent: 'text-mce-gold/70',
    desc: 'text-mce-gold/80',
    label: 'text-mce-gold',
    iconBorder: 'border-mce-gold/40',
    iconFill: 'text-mce-gold',
    dotActive: 'bg-mce-gold',
    dotInactive: 'bg-mce-gold/30 hover:bg-mce-gold/60',
  },
};

const MOBILE_SLIDES = HERO_SLIDES.filter((s) => s.mobileImg !== null);

export default function Evenementiel() {
  // ================== SLIDESHOW HERO ==================
  const [heroIdx, setHeroIdx] = useState(0);
  const [mobileIdx, setMobileIdx] = useState(0);
  const [heroPaused, setHeroPaused] = useState(false);

  useEffect(() => {
    if (heroPaused) return;
    const t = setInterval(() => {
      setHeroIdx((i) => (i + 1) % HERO_SLIDES.length);
      setMobileIdx((i) => (i + 1) % MOBILE_SLIDES.length);
    }, 4000);
    return () => clearInterval(t);
  }, [heroPaused]);

  const desktopSlide = HERO_SLIDES[heroIdx];
  const desktopColor = COLOR_MAP[desktopSlide.colorDesktop];

  const mobileSlide = MOBILE_SLIDES[mobileIdx];
  const mobileColor = COLOR_MAP[mobileSlide.colorMobile];

  // ================== FORMULAIRE DEVIS ==================
  const [quote, setQuote] = useState({
    services: [],
    location: '',
    theme: '',
    audiences: [],
    deadlines: [],
    name: '',
    email: '',
    phone: '',
    details: '',
    consent: false,
  });
  const [sending, setSending] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const toggle = (key, value) =>
    setQuote((q) => ({
      ...q,
      [key]: q[key].includes(value) ? q[key].filter((x) => x !== value) : [...q[key], value],
    }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formElement = e.currentTarget;
    setError('');

    if (!quote.services.length) {
      setError('Choisissez au moins un type d\u2019événement (mariage ou soirée).');
      return;
    }
    if (!quote.name || !quote.email || !quote.phone) {
      setError('Nom, email et téléphone sont obligatoires.');
      return;
    }
    if (!quote.consent) {
      setError('Merci d\u2019accepter la politique de traitement des données.');
      return;
    }

    setSending(true);
    try {
      await submitRequest('event', {
          from_name: 'Site MCE — Accompagnement Mariages & Soirées Privées',
          subject: `Nouvelle demande de devis Mariage / Soirée — ${quote.name}`,
          type_de_demande: 'Devis Accompagnement Mariage & Soirée Privée',
          type_evenement: quote.services.join(', '),
          lieu: quote.location || 'À définir',
          theme: quote.theme || 'À définir',
          nombre_personnes: quote.audiences.join(', ') || 'Non précisé',
          delai: quote.deadlines.join(', ') || 'À définir',
          nom: quote.name,
          email: quote.email,
          telephone: quote.phone,
          details: quote.details || 'Aucun détail',
          consentement: 'Accepté',
      }, formElement);

      setSubmitted(true);
      setQuote({
        services: [],
        location: '',
        theme: '',
        audiences: [],
        deadlines: [],
        name: '',
        email: '',
        phone: '',
        details: '',
        consent: false,
      });

      setTimeout(() => setSubmitted(false), 12000);
    } catch (err) {
      setError('Envoi impossible. Réessayez ou contactez-nous directement sur WhatsApp.');
    } finally {
      setSending(false);
    }
  };

  // ================== RENDU ==================
  return (
    <div className="pt-[72px]">
      {/* ========================================================= */}
      {/* ===================== HERO SLIDESHOW ==================== */}
      {/* ========================================================= */}

      {/* ============= VERSION DESKTOP (md+) ============== */}
      <section
        className="hidden md:block relative overflow-hidden h-[620px] lg:h-[680px]"
        onMouseEnter={() => setHeroPaused(true)}
        onMouseLeave={() => setHeroPaused(false)}
      >
        {HERO_SLIDES.map((s, i) => (
          <div
            key={i}
            className="absolute inset-0 transition-opacity duration-700 ease-in-out"
            style={{
              opacity: i === heroIdx ? 1 : 0,
              backgroundImage: `url(${s.desktopImg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center 45%',
            }}
          />
        ))}

        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 h-full flex items-center">
          <div className="max-w-2xl">
            <p
              key={`label-desktop-${heroIdx}`}
              className={`text-[11px] lg:text-[12px] tracking-[0.28em] font-bold transition-colors duration-500 ${desktopColor.label}`}
            >
              {desktopSlide.label}
            </p>

            <h1
              key={`title-desktop-${heroIdx}`}
              className={`mt-6 text-4xl md:text-5xl lg:text-[56px] font-black leading-[1.05] tracking-tight transition-colors duration-500 ${desktopColor.main}`}
            >
              {desktopSlide.line1}
              <br />
              <span className={desktopColor.accent}>{desktopSlide.line2}</span>
            </h1>

            <p
              key={`desc-desktop-${heroIdx}`}
              className={`mt-6 text-[14px] lg:text-[15px] leading-relaxed max-w-lg transition-colors duration-500 ${desktopColor.desc}`}
            >
              {desktopSlide.desc}
            </p>

            <div className="mt-10 grid grid-cols-3 gap-4 max-w-xl">
              {[
                { icon: Crown, title: 'Sur-mesure', sub: 'Chaque détail compte' },
                { icon: Globe, title: '3 pays', sub: 'France · Sénégal · Maroc' },
                { icon: Heart, title: 'Émotion', sub: 'Des souvenirs éternels' },
              ].map((f, i) => (
                <div key={i} className="flex flex-col items-start gap-2">
                  <div
                    className={`w-9 h-9 rounded-full border flex items-center justify-center transition-colors duration-500 ${desktopColor.iconBorder}`}
                  >
                    <f.icon className={`w-4 h-4 transition-colors duration-500 ${desktopColor.iconFill}`} />
                  </div>
                  <div className={`text-[11px] leading-tight transition-colors duration-500 ${desktopColor.main}`}>
                    <div className="font-semibold">{f.title}</div>
                    <div className={`transition-colors duration-500 ${desktopColor.accent}`}>{f.sub}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {HERO_SLIDES.map((_, i) => (
            <button
              key={i}
              onClick={() => setHeroIdx(i)}
              aria-label={`Slide ${i + 1}`}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === heroIdx ? `w-10 ${desktopColor.dotActive}` : `w-2 ${desktopColor.dotInactive}`
              }`}
            />
          ))}
        </div>
      </section>

      {/* ============= VERSION MOBILE (<md) =============== */}
      <section className="md:hidden relative overflow-hidden h-[calc(100vh-72px)] min-h-[560px] max-h-[720px]">
        <div className="hidden">
          {MOBILE_SLIDES.map((s, i) => (
            <img key={`preload-${i}`} src={s.mobileImg} alt="" />
          ))}
        </div>

        {MOBILE_SLIDES.map((s, i) => (
          <img
            key={i}
            src={s.mobileImg}
            alt=""
            className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out"
            style={{
              opacity: i === mobileIdx ? 1 : 0,
              zIndex: i === mobileIdx ? 1 : 0,
            }}
          />
        ))}

        <div className="relative z-10 h-full flex flex-col px-6 pt-8 pb-6">
          <div>
            <p
              key={`label-mobile-${mobileIdx}`}
              className={`text-[10px] tracking-[0.28em] font-bold transition-colors duration-500 ${mobileColor.label}`}
            >
              {mobileSlide.label}
            </p>

            <h1
              key={`title-mobile-${mobileIdx}`}
              className={`mt-3 text-[26px] font-black leading-[1.15] tracking-tight ${mobileColor.main}`}
            >
              {mobileSlide.line1}{' '}
              <span className={mobileColor.accent}>{mobileSlide.line2}</span>
            </h1>

            <p
              key={`desc-mobile-${mobileIdx}`}
              className={`mt-4 text-[13.5px] leading-relaxed max-w-[85%] ${mobileColor.desc}`}
            >
              {mobileSlide.desc}
            </p>

            <div className="grid grid-cols-2 gap-x-5 gap-y-5 max-w-[85%] mt-6">
              {[
                { icon: Crown, title: 'Sur-mesure', sub: 'Chaque détail compte' },
                { icon: Heart, title: 'Émotion', sub: 'Des souvenirs éternels' },
              ].map((f, i) => (
                <div key={i} className="flex flex-col items-start gap-2">
                  <div
                    className={`w-11 h-11 rounded-full border flex items-center justify-center transition-colors duration-500 ${mobileColor.iconBorder}`}
                  >
                    <f.icon className={`w-5 h-5 transition-colors duration-500 ${mobileColor.iconFill}`} />
                  </div>
                  <div className={`text-[12px] leading-tight transition-colors duration-500 ${mobileColor.main}`}>
                    <div className="font-bold">{f.title}</div>
                    <div className={`transition-colors duration-500 ${mobileColor.accent}`}>{f.sub}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-auto pt-4 flex justify-center gap-2">
            {MOBILE_SLIDES.map((_, i) => (
              <button
                key={i}
                onClick={() => setMobileIdx(i)}
                aria-label={`Slide ${i + 1}`}
                className={`h-1.5 rounded-full transition-all duration-300 ${
                  i === mobileIdx ? `w-8 ${mobileColor.dotActive}` : `w-1.5 ${mobileColor.dotInactive}`
                }`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* ========================================================= */}
      {/* ===================== 3 PAYS ============================ */}
      {/* ========================================================= */}
      <section id="pays-evenementiels" className="py-16 lg:py-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2 className="section-title mt-3 text-center">
            Trois pays, <span className="text-mce-teal">trois façons de célébrer</span>.
          </h2>
          <div className="h-1 w-16 bg-mce-teal mx-auto rounded-full mt-3 mb-12" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              {
                country: 'FRANCE',
                desc: 'Soirées privées & réceptions',
                img: franceSoiree,
                objectPosition: 'center 40%',
              },
              {
                country: 'SÉNÉGAL',
                desc: 'Mariages & cérémonies traditionnelles',
                img: senegalHenne,
                objectPosition: 'center 10%',
              },
              {
                country: 'MAROC',
                desc: 'Mariages royaux & grandes réceptions',
                img: marocMariage,
                objectPosition: 'center 30%',
              },
            ].map((c, index) => (
              <article className="event-country-item" key={c.country}>
                <div
                  className="event-country-card relative rounded-2xl overflow-hidden shadow-md h-[280px] card-hover"
                  style={{ '--country-index': index }}
                  tabIndex={0}
                >
                  <img
                    src={c.img}
                    alt={c.country}
                    className="absolute inset-0 w-full h-full object-cover"
                    style={{ objectPosition: c.objectPosition || 'center' }}
                  />
                  <div className="event-country-overlay absolute inset-0" />
                  <div className="event-country-content relative h-full p-6 flex flex-col justify-between text-white">
                    <div />
                    <div className="event-country-copy">
                      <h3 className="text-2xl font-black tracking-tight">{c.country}</h3>
                      <p className="text-[13px] text-white/85 mt-2 max-w-[260px]">{c.desc}</p>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ========================================================= */}
      {/* ===================== NOS PRESTATIONS =================== */}
      {/* ========================================================= */}
      <section id="prestations-evenementielles" className="pb-16 lg:pb-20 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <h2 className="section-title mt-3 text-center">Ce que nous organisons pour vous.</h2>
          <div className="h-1 w-16 bg-mce-teal mx-auto rounded-full mt-3 mb-12" />

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5">
            {[
              { icon: Heart, title: 'MARIAGES &\nCÉRÉMONIES', text: 'Mariages traditionnels et modernes, fiançailles, henné, cérémonies religieuses et civiles.' },
              { icon: PartyPopper, title: 'SOIRÉES\nPRIVÉES', text: 'Anniversaires, soirées à thème, galas, baby showers et événements familiaux.' },
              { icon: Palette, title: 'DÉCORATION &\nSCÉNOGRAPHIE', text: 'Concepts créatifs sur-mesure, mise en scène florale, lumineuse et artistique.' },
              { icon: Music, title: 'ANIMATION &\nSPECTACLE', text: 'DJ, musiciens, artistes, photographes, vidéastes et divertissement.' },
              { icon: Calendar, title: 'COORDINATION\nCOMPLÈTE', text: 'Planification, logistique, traiteur, prestataires, budget et suivi jour J.' },
            ].map((p) => (
              <div
                key={p.title}
                className="rounded-2xl bg-white border border-gray-100 shadow-sm p-5 text-center card-hover"
              >
                <div className="w-14 h-14 rounded-full bg-mce-teal/10 flex items-center justify-center mx-auto">
                  <p.icon className="w-7 h-7 text-mce-teal" />
                </div>
                <h3 className="mt-4 text-[13px] font-black text-mce-navy whitespace-pre-line leading-tight">
                  {p.title}
                </h3>
                <p className="mt-3 text-[11.5px] text-mce-navy/70 leading-relaxed">{p.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ========================================================= */}
      {/* ============ POURQUOI CHOISIR + PROCESSUS ============== */}
      {/* ========================================================= */}
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
          <div className="rounded-2xl bg-white border border-gray-100 shadow-md p-6 lg:p-8">
            <h2 className="event-process-title text-center font-black text-mce-teal">
              Faisons de votre événement un moment inoubliable en 5 étapes
            </h2>
            <div className="h-1 w-12 bg-mce-teal mx-auto rounded-full mt-3 mb-8" />

            <div className="relative">
              <div className="hidden lg:block absolute top-8 left-[10%] right-[10%] border-t-2 border-dashed border-mce-teal/30" />

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 relative">
                {[
                  { title: 'ÉCOUTER', text: 'Comprendre votre vision, vos envies et vos contraintes.', icon: MessageCircle, tone: 'teal' },
                  { title: 'IMAGINER', text: 'Créer un concept unique adapté à votre histoire.', icon: Sparkles, tone: 'teal' },
                  { title: 'ORGANISER', text: 'Sélectionner les prestataires, planifier chaque détail.', icon: ClipboardList, tone: 'teal' },
                  { title: 'CÉLÉBRER', text: 'Coordonner le jour J pour une exécution parfaite.', icon: Star, tone: 'navy' },
                  { title: 'SUBLIMER', text: 'Capturer les souvenirs et prolonger la magie.', icon: Award, tone: 'navy' },
                ].map((s) => {
                  const bg =
                    s.tone === 'teal-light' ? 'bg-mce-teal/70' : s.tone === 'teal' ? 'bg-mce-teal' : 'bg-mce-navy';
                  return (
                    <div key={s.title} className="text-center event-process-step">
                      <div className={`event-process-icon w-16 h-16 rounded-full ${bg} mx-auto flex items-center justify-center shadow-md`}>
                        <s.icon className="w-7 h-7 text-white" />
                      </div>
                      <div className="text-[13px] font-black text-mce-navy mt-4">{s.title}</div>
                      <p className="mt-2 text-[11px] text-mce-navy/70 leading-snug px-1">{s.text}</p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========================================================= */}
      {/* ======= FORMULAIRE DEVIS MARIAGES & SOIRÉES PRIVÉES ===== */}
      {/* ========================================================= */}
      <section id="devis-events" className="py-20 text-white" style={{ background: 'linear-gradient(180deg, #0A2540 0%, #081B2E 100%)' }}>
        <h2
            className="text-3xl md:text-4xl lg:text-[42px] font-black text-center leading-tight"
            style={{ color: 'text-mce-navy' }}
          >
            Parlons de votre projet
        </h2><br />
        <div className="mx-auto max-w-[1100px] px-6">
          {/* Message succès */}
          {submitted && (
            <div className="rounded-lg p-4 mb-6 flex items-center gap-3" style={{ backgroundColor: 'rgba(34,197,94,0.15)', border: '1px solid rgba(34,197,94,0.4)' }}>
              <CheckCircle2 className="w-5 h-5 text-green-400 shrink-0" />
              <p className="text-[14px] font-semibold text-green-200">Votre demande a bien été envoyée. MCE vous recontacte sous 48h.</p>
            </div>
          )}

          {/* Message erreur */}
          {error && (
            <div className="rounded-lg p-4 mb-6" style={{ backgroundColor: 'rgba(239,68,68,0.15)', border: '1px solid rgba(239,68,68,0.4)' }}>
              <p className="text-[13px] font-semibold text-red-300">{error}</p>
            </div>
          )}

          {/* Formulaire blanc */}
          <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-2xl p-6 md:p-10 space-y-8 text-[#0F1E3D]">
            <input type="checkbox" name="botcheck" tabIndex="-1" autoComplete="off" className="hidden" />

            {/* Q1 — Type d'événement */}
            <QuoteGroup title="1. Quel type d'événement souhaitez-vous organiser ?" note="Un ou plusieurs choix possibles" required>
              {SERVICES.map((s) => (
                <CheckOption key={s} label={s} checked={quote.services.includes(s)} onChange={() => toggle('services', s)} />
              ))}
            </QuoteGroup>

            {/* Q2 — Lieu */}
            <fieldset>
              <legend className="mb-3">
                <span className="font-bold text-[15px]" style={{ color: '#0F1E3D' }}>
                  2. Lieu envisagé
                </span>
                <span className="block text-[12px] mt-0.5" style={{ color: 'rgba(15,30,61,0.55)' }}>
                  Ville, région ou pays — même à titre indicatif
                </span>
              </legend>
              <div className="relative">
                <MapPin className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2" style={{ color: 'rgba(15,30,61,0.5)' }} />
                <input
                  type="text"
                  value={quote.location}
                  onChange={(e) => setQuote({ ...quote, location: e.target.value })}
                  placeholder="Ex. : Dakar, Marrakech, Saly…"
                  className="w-full rounded-md border border-gray-200 pl-9 pr-3 py-2 text-[14px] text-gray-800 focus:outline-none focus:ring-2 transition-colors"
                  style={{ '--tw-ring-color': 'rgba(0,153,204,0.3)' }}
                />
              </div>
            </fieldset>

            {/* Q3 — Thème */}
            <fieldset>
              <legend className="mb-3">
                <span className="font-bold text-[15px]" style={{ color: '#0F1E3D' }}>
                  3. Thème ou ambiance souhaitée
                </span>
                <span className="block text-[12px] mt-0.5" style={{ color: 'rgba(15,30,61,0.55)' }}>
                  Décrivez le style, la couleur dominante, l'univers, la culture ou l'inspiration
                </span>
              </legend>
              <input
                type="text"
                value={quote.theme}
                onChange={(e) => setQuote({ ...quote, theme: e.target.value })}
                placeholder="Ex. : bohème chic, oriental moderne, glamour Gatsby, tropical, traditionnel africain…"
                className="w-full rounded-md border border-gray-200 px-3 py-2 text-[14px] text-gray-800 focus:outline-none focus:ring-2 transition-colors"
                style={{ '--tw-ring-color': 'rgba(0,153,204,0.3)' }}
              />
            </fieldset>

            {/* Q4 — Nombre de personnes */}
            <QuoteGroup title="4. Nombre de personnes attendues" note="Un ou plusieurs choix possibles">
              {AUDIENCE_SIZES.map((a) => (
                <CheckOption key={a} label={a} checked={quote.audiences.includes(a)} onChange={() => toggle('audiences', a)} />
              ))}
            </QuoteGroup>

            {/* Q5 — Délai / date */}
            <QuoteGroup title="5. Quand souhaitez-vous organiser cet événement ?" note="Un ou plusieurs choix possibles">
              {DEADLINES.map((d) => (
                <CheckOption key={d} label={d} checked={quote.deadlines.includes(d)} onChange={() => toggle('deadlines', d)} />
              ))}
            </QuoteGroup>

            {/* Q6 — Détails */}
            <fieldset>
              <legend className="mb-3">
                <span className="font-bold text-[15px]" style={{ color: '#0F1E3D' }}>
                  6. Détails de votre projet
                </span>
                <span className="block text-[12px] mt-0.5" style={{ color: 'rgba(15,30,61,0.55)' }}>
                  Décrivez votre vision, vos envies, vos contraintes ou vos priorités
                </span>
              </legend>
              <textarea
                rows={5}
                value={quote.details}
                onChange={(e) => setQuote({ ...quote, details: e.target.value })}
                placeholder="Ex. : date précise si connue, nombre d'invités VIP, prestations souhaitées (traiteur, décoration, animation, DJ, photographe…), budget indicatif, contraintes particulières…"
                className="w-full rounded-md border border-gray-200 px-3 py-2 text-[14px] text-gray-800 focus:outline-none focus:ring-2 transition-colors"
                style={{ '--tw-ring-color': 'rgba(0,153,204,0.3)' }}
              />
            </fieldset>

            {/* Coordonnées */}
            <div className="pt-6 border-t border-gray-200">
              <h3 className="font-black text-lg mb-4" style={{ color: '#0F1E3D' }}>Vos coordonnées</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <TextField label="Nom complet *" value={quote.name} onChange={(v) => setQuote({ ...quote, name: v })} required />
                <TextField label="Email *" type="email" value={quote.email} onChange={(v) => setQuote({ ...quote, email: v })} required />
                <TextField label="Téléphone / WhatsApp *" type="tel" value={quote.phone} onChange={(v) => setQuote({ ...quote, phone: v.replace(/[^0-9+()\s-]/g, '') })} required />
              </div>
            </div>

            {/* Consentement */}
            <label className="flex items-start gap-3 cursor-pointer">
              <input
                type="checkbox"
                checked={quote.consent}
                onChange={(e) => setQuote({ ...quote, consent: e.target.checked })}
                className="mt-1 w-4 h-4 shrink-0 rounded"
                style={{ accentColor: '#0099CC' }}
              />
              <span className="text-[12.5px]" style={{ color: 'rgba(15,30,61,0.75)' }}>
                J'accepte que MCE utilise ces informations pour étudier ma demande. Le devis devient contractuel uniquement après validation écrite des parties.
              </span>
            </label>

            <AttachmentField />
            {/* Bouton envoyer */}
            <div className="flex flex-col gap-4 pt-2">
              <p className="text-[12px] text-center" style={{ color: 'rgba(15,30,61,0.6)' }}>
                Réponse sous 48h · Devis gratuit et sans engagement.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <button
                  type="submit"
                  disabled={sending}
                  className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md font-bold text-[13px] tracking-wide shadow-lg hover:shadow-xl transition-all disabled:opacity-60 disabled:cursor-wait"
                  style={{ backgroundColor: '#0F1E3D', color: '#FFB800' }}
                >
                  <Send className="w-4 h-4" />
                  {sending ? 'Envoi en cours…' : 'Envoyer ma demande'}
                  {!sending && <ArrowRight className="w-4 h-4" />}
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}

/* ============ COMPOSANTS INTERNES ============ */

function QuoteGroup({ title, note, required, children }) {
  return (
    <fieldset>
      <legend className="mb-3">
        <span className="font-bold text-[15px]" style={{ color: '#0F1E3D' }}>
          {title} {required && <span style={{ color: '#dc2626' }}>*</span>}
        </span>
        {note && <span className="block text-[12px] mt-0.5" style={{ color: 'rgba(15,30,61,0.55)' }}>{note}</span>}
      </legend>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5">{children}</div>
    </fieldset>
  );
}

function CheckOption({ label, checked, onChange }) {
  return (
    <label
      className="flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition-all"
      style={{
        borderColor: checked ? '#0099CC' : 'rgb(229,231,235)',
        backgroundColor: checked ? 'rgba(0,153,204,0.06)' : '#ffffff',
      }}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="w-4 h-4 shrink-0"
        style={{ accentColor: '#0099CC' }}
      />
      <span className="text-[13.5px]" style={{ color: '#0F1E3D', fontWeight: checked ? 600 : 400 }}>
        {label}
      </span>
    </label>
  );
}

function TextField({ label, type = 'text', value, onChange, required }) {
  return (
    <div>
      <label className="text-[12px] font-semibold" style={{ color: 'rgba(15,30,61,0.8)' }}>{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="mt-1 w-full rounded-md border border-gray-200 px-3 py-2 text-[14px] text-gray-800 focus:outline-none focus:ring-2 transition-colors"
        style={{ '--tw-ring-color': 'rgba(0,153,204,0.3)' }}
      />
    </div>
  );
}
